import React, {memo} from 'react';
import ReactPlayer from "react-player";
import '../../Styles/FAQ.css'

/**
 * Checks whether the respective video is visible to logged-in user.
 * @param videoData
 * @param loggedInUserRole
 * @returns {boolean}
 */
function isVisible(videoData, loggedInUserRole) {
    let checkVisibility = false;
    videoData.visible.forEach(checkFunction)

    function checkFunction(videoVisibleItem) {

        if (checkVisibility === false) {
            checkVisibility = loggedInUserRole.includes(videoVisibleItem);
        }
    }

    return checkVisibility === true;
}

/**
 * Shows the respective video with visibility check depending on user role.
 * @param videoData
 * @returns {JSX.Element}
 * @constructor
 */
const FAQVideosListItem = ({videoData}) => {


    let loggedInUserRole = sessionStorage.getItem('roles')

    return (
        <>
            {isVisible(videoData, loggedInUserRole) &&

            <div className="faq-video-display">

                <ReactPlayer controls={true} width={'100%'}
                             url={videoData.URL}
                />
                <h5>{videoData.name}</h5>

            </div>
            }
        </>
    )

}

export default memo(FAQVideosListItem);